import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Mic, LayoutDashboard, Settings, CreditCard, LogOut, Shield } from 'lucide-react';

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const links = [
    { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { to: '/pricing', icon: CreditCard, label: 'Pricing' },
    { to: '/settings', icon: Settings, label: 'Settings' },
  ];

  if (user?.is_admin) {
    links.push({ to: '/admin', icon: Shield, label: 'Admin' });
  }

  return (
    <aside className="sidebar flex flex-col" data-testid="sidebar">
      <div className="p-6">
        <Link to="/" className="flex items-center" data-testid="sidebar-logo">
          <img 
            src="/logo-full.png" 
            alt="EpisodeKit" 
            className="h-10 w-auto"
          />
        </Link>
      </div>

      <nav className="flex-1 px-4 space-y-1">
        {links.map((link) => {
          const Icon = link.icon;
          const isActive = location.pathname === link.to;
          return (
            <Link
              key={link.to}
              to={link.to}
              className={`sidebar-link ${isActive ? 'active' : ''}`}
              data-testid={`sidebar-link-${link.label.toLowerCase()}`}
            >
              <Icon className="w-5 h-5" />
              <span>{link.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="p-4 border-t border-neutral-800">
        <div className="mb-4 p-3 rounded-lg bg-neutral-900/50">
          <p className="text-sm text-neutral-400">Current Plan</p>
          <p className="font-semibold capitalize text-primary">{user?.plan || 'Free'}</p>
          <p className="text-xs text-neutral-500 mt-1">
            {user?.episodes_used || 0} / {user?.episodes_limit === 999 ? '∞' : user?.episodes_limit || 1} episodes
          </p>
          {user?.subscription_status === 'active' && (
            <p className="text-xs text-success mt-1">Active subscription</p>
          )}
        </div>
        <button
          onClick={handleLogout}
          className="sidebar-link w-full text-red-400 hover:text-red-300 hover:bg-red-500/10"
          data-testid="logout-btn"
        >
          <LogOut className="w-5 h-5" />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
